
import { Box, Grid } from "@mui/material";
import { CargandoMedio, MensajeAlertaDanger } from "../../components";
import { useCategoriaSeccionCompras } from "../../../hooks/cache";
import { BuscarXTerminoAndReturn } from "../../components/buscadores";
import { CardsCategorias } from "../../categorias/components/CardsCategorias";





export const CategoriaScreenCliente = () => {


    const { data, isLoading, termino, chageTermino } = useCategoriaSeccionCompras();
    
    

    return (

        <Box sx={{width:'100%', px:5, py:4 }}>
            {(isLoading)
            ?   <CargandoMedio titulo="Cargando información de categorias y productos..." />
            :   <>
                <BuscarXTerminoAndReturn mT={3} termino={termino} chageTermino={chageTermino} texto="productos" playhol="nombre de producto o categoria" />
                {(data?.length < 1)
                ?   <MensajeAlertaDanger titulo="No hay información de categorias y prodcutos..." />
                :   <Grid container spacing={4} sx={{ justifyContent:"center", alignItems:"center" }}>
                        {data.map((categoria) => (
                            <CardsCategorias key={categoria.id} url="/filtro" {...categoria} />
                        ))}
                    </Grid>
                }
                </>
            }
        </Box>

    )
}
